"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => ({
  radio: {
    display: 'flex',
    flexDirection: 'column',
    '&.horizontal': {
      flexDirection: 'row'
    },
    '&.horizontal $item:not(:first-child)': {
      marginLeft: 16
    },
    '&.hidden': {
      display: 'none'
    },
    '&.disabled': {
      opacity: theme.disabledOpacity
    }
  },
  label: {
    marginBottom: 12
  },
  item: {
    flex: '0 0 auto'
  },
  helperText: {
    display: 'block',
    color: theme.checkbox.textColor
  }
});

exports.default = _default;